export default "__VITE_ASSET__DeM5e620__"